import React, { Component } from 'react'
import DataTable from '../../../components/Table/DataTable';
import UserImage from '../../../components/Image/UserImage';
import Button from '../../../components/CustomButtons/Button';
import { Remove, Add } from '@material-ui/icons';
import { Tooltip, Fab } from '@material-ui/core';
import SmallModal from '../../../components/Modal/SmallModal';
import Api from '../../../api/Api.js';
import UserEndpoints from '../../../api/UserEndpoints';
import ReportEndpoints from '../../../api/ReportEndpoints';
import PickUserDialog from './PickUserDialog';

const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "Avatar",
        options: {
            filter: false,
            sort: false,
            download: false
        }
    },
    {
        name: "Name",
        options: {
            filter: true,
            sort: true,
        }
    }
]

class ViewersTab extends Component {

    state = {
        addDialogOpen: false,
        removeDialogOpen: false,
        userToRemove: { id: 0, title: '' }
    }

    componentDidMount() {

    }

    render() {
        if (this.props.admin) {

            const { report_id } = this.props;

            return [
                <DataTable
                    key="data"
                    title={"People allowed to View this Report"}
                    data={this.props.users.map(user =>
                        [
                            user.id,
                            <UserImage {...user} />,
                            user.name + (user.surname ? (" " + user.surname) : ""),
                            <Tooltip title="Remove User" placement="top">
                                <Button round justIcon color="danger" onClick={() => this.setState({ removeDialogOpen: true, userToRemove: { id: user.id, title: user.name + (user.surname ? (" " + user.surname) : "") } })}>
                                    <Remove fontSize="large" />
                                </Button>
                            </Tooltip>
                        ]
                    )}
                    columns={columns.concat([
                        {
                            name: 'Remove',
                            options: {
                                filter: false,
                                sort: false,
                                download: false,
                                print: false
                            }
                        }
                    ])}
                />,
                <Fab
                    key="fab"
                    style={{ float: 'right' }}
                    color="primary"
                    onClick={() => this.setState({ addDialogOpen: true })}
                    variant="extended"
                >
                    Add Viewer <Add />
                </Fab>,
                <PickUserDialog
                    key="addDialog"
                    isOpen={this.state.addDialogOpen}
                    close={() => this.setState({ addDialogOpen: false })}
                    exclude={this.props.users.map(x => x.id)}
                    submit={(user_id) => {
                        Api.get(ReportEndpoints.addUser, { user_id, report_id })
                        .then(({ data }) => {
                            this.props.added(data);
                            this.setState({ addDialogOpen: false });
                        })
                        .catch((e) => {
                            console.error(e);
                        })
                    }}
                />,
                <SmallModal
                    key="areYouSureRemove"
                    isOpen={this.state.removeDialogOpen}
                    accept={() => {
                        Api.get(ReportEndpoints.removeUser, { user_id: this.state.userToRemove.id, report_id })
                            .then(({ data }) => {
                                this.props.removed(this.state.userToRemove.id);
                                this.setState({ removeDialogOpen: false });
                            })
                            .catch((e) => {
                                console.error(e);
                            })
                    }}
                    close={() => this.setState({ removeDialogOpen: false })}>
                    Are you sure you want to remove <span style={{ color: 'var(--primary)' }}>{this.state.userToRemove.title}</span> from the list of viewers?
                </SmallModal>
            ];
        } else {
            return (
                <DataTable
                    title={"People allowed to View this Report"}
                    data={this.props.users.map(user => [user.id, <UserImage {...user} />, user.name + (user.surname ? (" " + user.surname) : "")])}
                    columns={columns}
                />
            );
        }
    }
}

export default ViewersTab;